import clsx from 'clsx';
import type { CSSProperties, FunctionComponent, HTMLAttributes } from 'react';

/**
 * The block is a still fill; the shimmer is a highlight band on `::after` that moves by
 * `transform` alone, so it runs on the compositor without repainting the block. Reduced
 * motion stops the band. A caller's `animate-none` (written `!animate-none` or
 * `animate-none!`) keeps the block still too, for placeholders shown without a delay.
 */
const skeletonBaseClasses = clsx(
    'relative overflow-hidden rounded-md bg-skeleton-base',
    'after:absolute after:inset-0 after:bg-linear-to-r after:from-transparent after:via-skeleton-highlight after:to-transparent after:animate-skeleton-shimmer',
    'motion-reduce:after:hidden [&[class*=animate-none]]:after:hidden',
);

export const SkeletonBase: FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
    <div className={clsx(skeletonBaseClasses, className)} {...props} />
);

type SkeletonProps = {
    readonly borderRadius?: string | undefined;
    readonly className?: string | undefined;
    readonly height?: string | undefined;
    readonly style?: CSSProperties | undefined;
    readonly width?: string | undefined;
};

export const Skeleton: FunctionComponent<SkeletonProps> = ({ borderRadius, className, height, style, width }) => (
    <div
        className={clsx(skeletonBaseClasses, className)}
        data-testid="skeleton"
        style={{ borderRadius, height, width, ...style }}
    />
);
